module.exports = __webpack_public_path__ + "media/townhome_blank.dbcf2917.svg";